export default "__VITE_ASSET__XoyKxIBa__"